import React, { useEffect, useState } from 'react'
import userImage from '../../assets/images/User1.png';
import chevronRight from '../../assets/images/ChevronRight.png';

import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../../reducers/common.reducer";

import { getFundService, getUserInfoService } from '../../services/dashboard.service'
import BuyShare from './components/BuyShare';

const FundManagement = () => {
    const [fundData, setFundData] = useState([])
    const [userInfo, setUserInfo] = useState([])
    const [showBuyShare, setShowBuyShare] = useState(false)
    const [userId, setUserId] = useState('')

    const dispatch = useDispatch();

    const getFundData = async () => {
        dispatch(setIsLoading(true))

        try {
            const result = await getFundService();
            const infoResult = await getUserInfoService();
            if(result.data) {
                setFundData(result.data)
            }
            if(infoResult.data) {
                setUserInfo(infoResult.data)
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error?.includes('streaming buffer')
                    ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                    : error?.response?.data?.message || error?.message;

            dispatch(
                setToastMessage({
                    message: errorMessage,
                    type: "error",
                })
            );
        } finally {
        dispatch(setIsLoading(false))
        }
    }

    useEffect(() => {
        getFundData();
    },[]);

    let fundInHolder = fundData[0]?.fundInHolder ? fundData[0]?.fundInHolder : 0;
    let remain = fundData[0]?.remainToClaim ? fundData[0]?.remainToClaim : 0;
    let myremain = 0;
    let basicFund = 0;
    if(remain > 0) {
        myremain = remain;
    }
    else {
        myremain = remain * -1;
    }
    basicFund = parseInt(fundInHolder)  + parseInt(myremain);

    basicFund = parseInt(basicFund);
    fundInHolder = parseInt(fundInHolder);
    remain = parseInt(remain);

    let fundInHolderPercentage = (fundInHolder / basicFund) * 100;
    let remainToClaimPercentage = (remain / basicFund) * -100;

    let basicFundPercentage = Math.round(basicFund / basicFund) * 100;
    fundInHolderPercentage = Math.round(fundInHolderPercentage);
    remainToClaimPercentage = Math.round(remainToClaimPercentage);


    const handleBuyShare = (userId) => {
        setUserId(userId)
        setShowBuyShare(true)
    }

    const shareHolder = userInfo?.map(holder => {

        let finalBalanceInHolder = holder.fundInHolder - holder.balanceToClaim;

        return (
            <tr key={holder.userId} className='border-b-2'>
                <th className='text-userText p-4'>{(holder.shareHolder).toLocaleString()}</th>
                <th className='text-userText p-4'>{(holder.fundInHolder).toLocaleString()}</th>
                <th className='text-userText p-4'>{(holder.balanceToClaim).toLocaleString()}</th>
                <th className='text-attractive1 p-4'>{(finalBalanceInHolder).toLocaleString()}</th>
                <th className='flex gap-3 justify-center items-center'>
                    <button
                        className='bg-primary p-2 w-24 text-white rounded shadow-md font-semibold'
                        onClick={() => handleBuyShare(holder.userId)}
                    >
                        Buy Share
                    </button>


                </th>
                {/* <th>
                    <img src={chevronRight} alt=''/>
                </th> */}
            </tr>
        )
    })

    return (
        <div className='h-[88vh]'>
            <div className=''>
                <div className='flex w-[95%] m-auto pb-4 pt-2'>
                    <img src={userImage} className='w-8 me-3'/>
                    <div className='font-bold text-userText mt-0.5 text-lg'>/ User / Profit Sharing</div>
                </div>
            </div>
            <div className='w-[95%] m-auto grid lg:grid-cols-4 sm:grid-cols-1 gap-3 mb-5'>
                <div className='bg-white p-5 shadow-lg rounded-md'>
                    <div className='flex justify-between'>
                        <div className='font-bold mb-5'>
                            <h1 className='text-userText mb-2'>Basic Fund</h1>
                            <h1 className='text-black'>{basicFund.toLocaleString()}</h1>
                        </div>
                        {/* <p className='text-primary font-bold mt-5'>{basicFundPercentage}%</p> */}
                    </div>
                    <div className='h-1 bg-line'>
                        <div className="h-1 bg-primary" style={{ width: `${basicFundPercentage}%` }}></div>
                    </div>
                </div>
                <div className='bg-white p-5 shadow-lg rounded-md'>
                    <div className='flex justify-between'>
                        <div className='font-bold mb-5'>
                            <h1 className='text-userText mb-2'>Fund In Holder</h1>
                            <p className="text-xl font-bold">{fundInHolder.toLocaleString()}</p>
                        </div>
                        <p className='text-attractive1 font-bold mt-5'>{fundInHolderPercentage}%</p>
                    </div>
                    <div className='h-1 bg-line'>
                        <div className="h-1 bg-attractive1" style={{ width: `${fundInHolderPercentage}%` }}></div>
                    </div>
                </div>
                <div className='bg-white p-5 shadow-lg rounded-md'>
                    <div className='flex justify-between'>
                        <div className='font-bold mb-5'>
                            <h1 className='text-userText mb-2'>Remain to Claim</h1>
                            <h1 className='text-black'>{remain.toLocaleString()}</h1>
                        </div>
                        <p className='text-attractive2 font-bold mt-5'>{remainToClaimPercentage}%</p>
                    </div>
                    <div className='h-1 bg-line'>
                        <div className="h-1 bg-attractive2" style={{ width: `${remainToClaimPercentage}%` }}></div>
                    </div>
                </div>
                <div className='bg-white p-5 shadow-lg rounded-md'>
                    <div className='flex justify-between'>
                        <div className='font-bold mb-5'>
                            <h1 className='text-userText mb-2'>Agent</h1>
                            <h1 className='text-black'>{fundData && fundData[0] ? fundData[0].totalAgents : 0}</h1>
                        </div>
                    </div>
                    <div className='h-1 bg-line'>
                        <div className="h-1 bg-userText" style={{ width: "100%" }}></div>
                    </div>
                </div>
            </div>
            <div className='bg-white w-[95%] m-auto h-full'>
                {/* <div className='w-full pt-16 text-white flex font-bold mb-16 relative'>
                    <div className='flex gap-4 absolute'>
                        <button
                            className='bg-primary rounded py-2  px-6 md:px-8 lg:ms-20'

                        >
                                Buy Share
                        </button>
                        {/* <button className='bg-primary rounded px-4 md:px-8'>Share Withdraw</button>
                        <button className='bg-primary rounded px-4 md:px-8'>Profit Sharing</button>
                        <button className='bg-primary rounded  px-4 md:px-8'>History</button>
                        <input type="date" className='bg-bgColor text-userText rounded p-2 outline-none ml-0 md:ml-12 lg:ml-24'/>
                        <input type="date" className='bg-bgColor text-userText rounded p-2 outline-none'/> */}
                    {/* </div>
                </div> */}
                <table className='w-[90%] m-auto'>
                    <thead>
                        <tr className='text-userText border-b-2 border-borderColor h-16'>
                            <th>ShareHolder</th>
                            <th>Fund In Holder</th>
                            <th>Shared Profit</th>
                            <th>Final Basic Fund In Holder</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {shareHolder}
                    </tbody>
                </table>
            </div>

            {showBuyShare && <BuyShare showBuyShare={showBuyShare} setShowBuyShare={setShowBuyShare} userId={userId} />}
            <div className='h-16'></div>
        </div>
    )
}

export default FundManagement
